module.exports = __webpack_public_path__ + "static/media/visa.a4c70b02.png";